export const STORE_KEY = '@@menu'
export const GET_MENU_REQUEST = `${STORE_KEY}/GET_MENU_REQUEST`
export const GET_MENU_SUCCESS = `${STORE_KEY}/GET_MENU_SUCCESS`
export const GET_MENU_FAILURE = `${STORE_KEY}/GET_MENU_FAILURE`
